'use strict';

// Import Libraries
import React     from 'react';
import PropTypes from 'prop-types';
// Import Mixins
import ZipCodes from '../_libs/zip-codes';
import { isPostalCodeLocal } from '../_utils/validations';
// Import JS Modules
import genericHelpers from '../_utils/generic-helpers';

// -----------------------------------------------------------
//  StoreLocatorCommon
// -----------------------------------------------------------

const StoreLocatorCommon = {
  getInitialState: function() {
    return {
      zipCode: ZipCodes.load(),
      enteringZipCode: false,
      locations: [],
      selectedLocation: this.props.initialLocation,
      errorMessage: ''
    };
  },

  submitSearchForm: function(e){
    e.preventDefault();

    const zipCode = this.refs['zip-code'].value;
    if(isPostalCodeLocal(zipCode)) {
      this.spinFindButton();
      this.search(zipCode);
    } else {
      this.resetFindButton();
    }
  },

  search: function(zipCode){
    zipCode = (zipCode || this.state.zipCode);

    if(!zipCode || this.lastlookup === zipCode || !zipCode.match(/(\w\d\s)*/)) {
      this.resetFindButton();
      this.setState({
        enteringZipCode: false
      });
      return;
    }

    genericHelpers.findLocations(this.context.locationsUrl, zipCode, this.props.serviceFilter).
      then(locations => {
        this.resetFindButton();
        this.setState({
          zipCode: zipCode,
          locations: locations,
          enteringZipCode: false,
          errorMessage: ''
        });
      }).
      catch(errorMessage => {
        this.resetFindButton();
        this.setState({
          zipCode: zipCode,
          locations: [],
          enteringZipCode: false,
          errorMessage: errorMessage
        });
      });

    this.lastlookup = zipCode;
    ZipCodes.save(zipCode);
  },

  spinFindButton: function() {
    const btnFind = this.refs['btn-find'];
    btnFind && btnFind.spin();
  },
  resetFindButton: function() {
    const btnFind = this.refs['btn-find'];
    btnFind && btnFind.reset();
  }
};

StoreLocatorCommon.contextTypes = {
  locationsUrl: PropTypes.string
};

export default StoreLocatorCommon;
